module.exports = __webpack_public_path__ + "0c2936b3ceeb3d43a3de0b7b9ae426f6.png";